var MessageTypesRequest = /** @class */ (function () {
    function MessageTypesRequest() {
        this.Action = 'getmessagetypes';
    }
    return MessageTypesRequest;
}());
export { MessageTypesRequest };
